import React, { useState } from "react";

import { MobileTimePicker, MobileTimePickerProps } from "@mui/lab";
import { InputAdornment, TextField, TextFieldProps } from "@mui/material";
import { ClockIcon } from "../../globals/design-system/icons";

type MoovsTimePickerProps = {
  onAccept?: (date: any) => void;
  renderInputProps?: TextFieldProps;
  clearable?: boolean;
  disabled?: boolean;
} & Omit<
  MobileTimePickerProps,
  "onChange" | "renderInput" | "onClose" | "InputProps" | "clearable" | "open"
>;

function MoovsTimePicker(props: MoovsTimePickerProps) {
  const {
    renderInputProps = {},
    clearable = false,
    onAccept,
    disabled,
    ...otherProps
  } = props;

  // state
  const [openTimePicker, setOpenTimePicker] = useState(false);

  // event handlers
  const handleClosePicker = () => setOpenTimePicker(false);
  const handleOpenPicker = () => {
    if (!disabled) {
      setOpenTimePicker(true);
    }
  };

  const handleAccept = (date) => {
    onAccept(date);
    handleClosePicker();
  };

  return (
    <MobileTimePicker
      {...otherProps}
      disabled={disabled}
      open={openTimePicker}
      clearable={clearable}
      onChange={() => {}}
      onAccept={handleAccept}
      onClose={handleClosePicker}
      inputFormat="h:mm A"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <ClockIcon />
          </InputAdornment>
        ),
        style: { cursor: "pointer" },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          onClick={handleOpenPicker}
          variant="outlined"
          fullWidth
          inputProps={{
            ...params.inputProps,
            style: { cursor: "pointer" },
          }}
          {...renderInputProps}
        />
      )}
    />
  );
}
export default MoovsTimePicker;
